<template>
      <div class="p4">
            <core-form-input
                  componentName="j-base-input-text"
                  name="startDate"
                  subheadline="DD/MM/YYYY"
                  :label="$t('start_date')"
                  v-validate="'required'"
                  v-model="form.startDate"
                  :validationErrors="errors"
                  class="mb6"
            />
            <core-form-input
                  componentName="j-base-input-text"
                  name="endDate"
                  subheadline="DD/MM/YYYY"
                  :label="$t('end_date')"
                  v-validate="'required'"
                  v-model="form.endDate"
                  :validationErrors="errors"
                  class="mb6"
            />
            <core-form-input
                  componentName="j-base-input-text"
                  name="referralCode"
                  subheadline="Referral Code"
                  :label="$t('referrer')"
                  v-validate="'required'"
                  v-model="form.refferalCode"
                  :validationErrors="errors"
                  class="mb6"
            />
            <j-button type="primary" @click="handleUpdate" :isLoading="isLoading">{{ $t("update") }}</j-button>
      </div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton/"
import { transformDate } from "@/utils/"
import dayjs from "dayjs"
import api from "../api/"

export default {
	components: { CoreFormInput, JButton },

	data() {
		return {
			form: {
				startDate: dayjs(this.particulars.startDate).format(
					"DD/MM/YYYY"
				),
				endDate: dayjs(this.particulars.endDate).format(
					"DD/MM/YYYY"
        ),
        refferalCode: this.particulars.referrer?.internalCode
			},

			isLoading: false
		}
	},

	props: {
		particulars: Object
	},

	methods: {
		async handleUpdate() {
			const policyId = this.particulars.id

			const updatedPolicy = {
				endDate: transformDate(this.form.endDate),
        startDate: transformDate(this.form.startDate),
        referralCode: this.form.refferalCode
			}

			this.isLoading = true

			const res = await api.updateQuote({
				policyId,
				updatedPolicy
			})

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.isLoading = false

			this.$emit("updated")
		}
	}
}
</script>
